import { useMutation } from '@tanstack/react-query';
import { adminFetch } from './useAdminApi';

/**
 * useSendLetter — free-form DocuPost LETTER preview/send (superadmin).
 *
 * preview (default): renders + uploads the PDF, returns its signed URL. Does
 * NOT spend postage. send: also calls DocuPost + logs to orders.mail_log
 * (kind='letter'). Mails regardless of the customer's paper opt-in flags.
 */

interface MailTo {
  name: string;
  address1: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface LetterPreview {
  ok: true;
  mode: 'preview';
  pdf_url: string;
  to: MailTo;
}

export interface LetterSend {
  ok: boolean;
  mode: 'send';
  pdf_url: string;
  docupost: { status: number; raw: string; id: string | null };
  mail_log_id: string | null;
}

export type LetterResult = LetterPreview | LetterSend;

export interface SendLetterInput {
  customer_id: string;
  title: string;
  body: string;
  mode: 'preview' | 'send';
}

export function useSendLetter() {
  return useMutation<LetterResult, Error, SendLetterInput>({
    mutationFn: (input) =>
      adminFetch<LetterResult>('admin-send-letter', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
  });
}
